import { BackgroundCircleSvg } from './BackgroundCircle.svg';

import { IconManager, IconManagerProps } from '@speeki/icons';

import {
    BackgroundCircleWrapper,
    CircleIconWrapper,
    CustomIconWrapper,
} from './BackgroundCircle.styled';

export interface BackgroundCircleProps {
    className?: string;
    fill?: string;
    iconProps?: IconManagerProps;
}

export const BackgroundCircle = ({
    className,
    fill,
    iconProps,
}: BackgroundCircleProps) => (
    <BackgroundCircleWrapper className={className}>
        <CircleIconWrapper>
            <BackgroundCircleSvg fill={fill} />
        </CircleIconWrapper>
        {iconProps && (
            <CustomIconWrapper>
                <IconManager {...iconProps} />
            </CustomIconWrapper>
        )}
    </BackgroundCircleWrapper>
);
